import { Box, Button, CircularProgress, Dialog, DialogContent, TextField, Typography, useTheme } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Icons } from '../../../utils/utilities'
import { useParams } from 'react-router-dom'
import { useQuizAndQuestionbankStore } from '../../../store/quizandquestionbank.store'

const CreateTopicDialog = ( { setState, state, bankId } ) => {

    const [loading, setLoading] = useState( true )
    const [fieldValue, setFieldValue] = useState( "" )
    const [adding, setAdding] = useState( false )
    const { bank_id = bankId } = useParams()

    const { palette, border } = useTheme()

    const QuizStore = useQuizAndQuestionbankStore()

    const handleClose = () => {
        setFieldValue( "" )
        setState( false )
    }

    const createTopic = async ( e ) => {
        if ( ( e.type === "keydown" && e.key === "Enter" ) || e.type === "click" ) {
            setAdding( true )
            if ( fieldValue && fieldValue?.trim().length > 0 ) {
                if ( fieldValue.length < 201 ) {
                    const success = await QuizStore.createTopic( bank_id, { question_bank_id: bank_id, name: fieldValue } )
                    if ( success ) {
                        setFieldValue( "" )
                        setState( false )
                    }
                }
            }
            setAdding( false )
        }
    }

    useEffect( () => {
        setLoading( false )
    }, [state] )

    return (
        <Dialog open={state} slotProps={{
            paper: { sx: { width: "90%", minWidth: "180px", maxWidth: "450px", background: palette.form.formCardBg } }
        }}>
            <DialogContent>
                <Typography variant="h6" flexGrow={1}>Create a new topic</Typography>
                {!loading && <Box borderRadius="5px" border={border[1]} marginTop="15px" padding="20px" bgcolor={palette.form.formBg}>
                    <Box>
                        <label htmlFor="topic-name">
                            <Typography display="block" color={palette.form.labelColor} gutterBottom variant="subtitle2">Topic name *</Typography>
                        </label>
                        <TextField autoComplete='off' id='topic-name' error={fieldValue.length >= 200} size="small" onKeyDown={createTopic} value={fieldValue} onChange={e => setFieldValue( e.target.value )} autoFocus fullWidth placeholder="Eg: Introduction" />
                        {fieldValue.length >= 200 && <Typography marginTop="5px" color="errorMessage.main" fontSize="12px" variant="subtitle2">Name too long! Max length: 200 characters</Typography>}
                    </Box>
                    <Box marginTop="40px" display="flex" alignItems="center" gap="20px">
                        <Button sx={{ textTransform: "capitalize" }} disabled={adding || fieldValue.length >= 200} onClick={createTopic} startIcon={adding ? <CircularProgress size={14} /> : Icons.default.AddIcon} variant="contained" disableElevation >Add Topic</Button>
                        <Button sx={{ textTransform: "capitalize" }} disabled={adding} onClick={handleClose} variant="contained" disableElevation color="error" >Cancel</Button>
                    </Box>
                </Box>}
            </DialogContent>
        </Dialog>
    )
}

export default CreateTopicDialog
